import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "reason-block" }
const _hoisted_2 = {
  class: "form-label",
  for: "delete-reason"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.modelValue,
    title: _ctx.title,
    width: "720px",
    "close-on-click-modal": false,
    "onUpdate:modelValue": _ctx.close,
    onOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reason = ''))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _ctx.close,
        disabled: _ctx.loading
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Отмена")
        ])),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode(_component_el_button, {
        type: _ctx.variant === 'restore' ? 'primary' : 'danger',
        loading: _ctx.loading,
        disabled: !_ctx.valid,
        onClick: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.confirmText), 1)
        ]),
        _: 1
      }, 8, ["type", "loading", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.reasonLabel), 1),
        _createVNode(_component_el_input, {
          id: "delete-reason",
          modelValue: _ctx.reason,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reason) = $event)),
          type: "textarea",
          rows: 3,
          maxlength: _ctx.DELETE_REASON_MAX,
          "show-word-limit": "",
          placeholder: `Не менее ${_ctx.DELETE_REASON_MIN} символов`
        }, null, 8, ["modelValue", "maxlength", "placeholder"])
      ])
    ]),
    _: 3
  }, 8, ["model-value", "title", "onUpdate:modelValue"]))
}